// gpt
import { az_ppt_completion } from "@/pptjs/api/api_azure_openai.js";
import { add_all_slides } from "../util/gpt_ppt";

// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";

// i18n
import { i18n } from "@i18n";

// 生成完整PPT
export async function createWholePPT(responseMessage) {
  let indexSymbol = responseMessage.indexOf("#");
  const generatedText = indexSymbol != -1 ? responseMessage.substr(indexSymbol) : responseMessage;
  // 显示文本去掉Markdown的符号
  if (indexSymbol != -1) {
    // 开始解析内容，构造单页ppt
    await add_all_slides(generatedText);
  } else {
    // 异常情况，gpt没有按照提示词要求生成marketdown格式的ppt文本，或者是market down结构但不包含标题结构的内容
    // todo 给用户友好提示
  }
  publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
}

// 旧的接口，暂时保留，几个版本后再丢弃，比如v3.0之后
export function process_ppt(input) {
  // 调用接口
  var params = {
    taskType: input.taskType ? input.taskType.id : "",
    taskOptions: input.taskOptions ? input.taskOptions.id : "",
    inputText: input.text,
  };
  az_ppt_completion(params).then(
    (response) => {
      handleChatGPTOpenAIResponse(params, response);
    },
    (error) => {
      handleChatGPTOpenAIError(error);
    }
  );
}

async function handleChatGPTOpenAIResponse(requestParams, response) {
  const taskTypes = [  
    "task_all_normal",  
    "task_bp_normal",  
    "task_bp_tan_methodology",  
    "taskType_ppt_from_file"  
  ];
  if (response.data.Code === 0) {
    let gptMessage = response.data.Result.Content;
    console.log("handleChatGPTOpenAIResponse:" + gptMessage);
    if (taskTypes.includes(response.data.Result.TaskType)) {
      let indexSymbol = gptMessage.indexOf("#");
      const generatedText = indexSymbol != -1 ? gptMessage.substr(indexSymbol) : gptMessage;
      // 显示文本去掉Markdown的符号
      if (indexSymbol != -1) {
        // 开始解析内容，构造单页ppt
        await add_all_slides(requestParams, generatedText);
      } else {
        // 普通GPT的答复，直接将文本显示为一条消息
        publish(gptPubIds.pubId_Local_Addin_SystemLog, gptMessage.replace(/\n/g, "<br />"));
      }
    } else {
      // 普通GPT的答复，直接将文本显示为一条消息
      publish(gptPubIds.pubId_Local_Addin_SystemLog, gptMessage.replace(/\n/g, "<br />"));
    }
    publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
  }
}

function handleChatGPTOpenAIError(error) {
  if (error) {
    publish(gptPubIds.pubId_Local_Addin_SystemLog, i18n.t("ppt_addin.process.text_ppt_generating_content_failed"));
    publish(gptPubIds.pubId_Local_Gpt_Processing_Fail, "");
  }
}
